import styled from '@emotion/styled';
import { DataGrid } from '@mui/x-data-grid';

import {
  blueBlack400,
  blueUltramarine500,
  greyLight100,
  greyLight300,
} from '../../../../theme/videa-style-tokens';

export const StyledDataGrid = styled(DataGrid)`
  height: 100%;
  width: 100%;

  .MuiDataGrid-columnHeaderTitleContainerContent {
    min-width: 4em;
  }

  &.MuiDataGrid-root,
  .MuiDataGrid-footerContainer {
    box-sizing: border-box;
    border: none;
  }

  &.MuiDataGrid-root .MuiDataGrid-footerContainer {
    display: ${({ hideFooter }) => (hideFooter ? 'none' : 'flex')};
  }

  .MuiDataGrid-main {
    border: none;

    .MuiDataGrid-virtualScroller {
      border: none;
    }
  }
  .MuiDataGrid-row {
    cursor: pointer;
    overflow: hidden;
    border-radius: 0.25em;
  }
  &.MuiDataGrid-root {
    .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon {
      width: 1em;
    }

    .MuiDataGrid-columnHeaderTitleContainer {
      white-space: break-spaces;

      .MuiDataGrid-columnHeaderTitleContainerContent {
        .MuiDataGrid-columnHeaderTitle,
        .column-head {
          font-size: 0.75em;
          overflow: hidden;
          white-space: break-spaces;
          text-overflow: visible;
          line-height: 1;
          width: 90%;
          padding-left: 1em;
        }
      }
    }
  }

  &.MuiDataGrid-root .MuiDataGrid-cell[data-field='revenue'] {
    position: relative;
    padding-left: 1em;

    :before {
      content: '$';
      position: absolute;
      left: 3em;
    }
  }

  &.MuiDataGrid-root .MuiDataGrid-cell[data-field='caseCompletionDollars'] {
    background-color: ${greyLight300};
  }
  &.MuiDataGrid-root .MuiDataGrid-cell[data-field='caseCompletionCounts'] {
    background-color: ${greyLight300};
  }

  &.MuiDataGrid-root .MuiDataGrid-cellContent {
    font-family: 'proxima-nova', sans-serif;
  }
  &.MuiDataGrid-root .MuiDataGrid-row {
    background-color: ${greyLight100};
    border: none;

    &:hover {
      background-color: ${greyLight300};
    }
  }

  &.MuiDataGrid-root .MuiDataGrid-columnHeaders {
    margin-bottom: 0.5em;
  }

  &.MuiDataGrid-root .MuiDataGrid-cell {
    background-color: transparent;
    border: none;
    -moz-font-feature-settings: 'tnum' 1;
    -moz-font-feature-settings: 'tnum=1';
    -webkit-font-feature-settings: 'tnum' 1;
    font-feature-settings: 'tnum' 1;
  }
  &.MuiDataGrid-root .MuiDataGrid-columnHeader:focus,
  &.MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    cursor: pointer;

    background-color: greyLight300;

    .MuiDataGrid-cellContent {
      color: blueUltramarine500;
    }
  }
  .sort-control {
    display: flex;
    align-items: center;
    font-family: 'proxima-nova', sans-serif;
    font-weight: 500;
    font-size: 0.77em;
    outline: none;
    border: none;
    background-color: transparent;
    cursor: pointer;

    .sort-indicator {
      margin-left: 0.5em;
      color: ${blueBlack400};
    }

    &:hover {
      color: ${blueUltramarine500};

      .sort-indicator {
        color: ${blueUltramarine500};
      }
    }
  }
`;
